import animate from './animate';

const scrollTo = (elementId, scrollParentId, scrollOptions = {}) => {
  if (typeof document !== 'object') {
    return;
  }
  const element = document && document.getElementById(elementId);
  if (!element) {
    return;
  }

  const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
  if (isSmoothScrollSupported) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
      ...scrollOptions
    });
    return;
  }

  const scrollParent = document && document.getElementById(scrollParentId);
  const rect = element.getBoundingClientRect();
  const scrollOffset =
    scrollParent?.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
  let to = scrollOffset + rect.top - 100;

  if (scrollOptions.block === 'end') {
    to = scrollOffset + rect.bottom - window.innerHeight;
  }
  animate({
    start: Date.now(),
    duration: 400,
    to,
    from: scrollOffset,
    callback(value) {
      if (scrollParent) {
        scrollParent.scrollTop = value;
        return;
      }
      document.documentElement.scrollTop = value;
      document.body.scrollTop = value;
    },
    delta(result) {
      return result;
    }
  });
};

export default scrollTo;
